import type { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { useCurrentUser } from '@/hooks/useCurrentUser.hook';
import { ROUTES } from '@/routes/route.config';
import type { AdminRole } from '@/types/user.types';

interface RequireRoleProps {
  roles: ReadonlyArray<AdminRole>;
}

/**
 * Role gate for route groups — must be nested inside RequireAuth, which owns the
 * loading / not-authenticated states. Server-side requireRole stays the source of truth;
 * this only keeps users out of screens their role can't use.
 */
const RequireRole: FC<RequireRoleProps> = ({ roles }) => {
  const { user } = useCurrentUser();

  if (user && !roles.includes(user.role)) {
    return <Navigate to={ROUTES.dashboard} replace />;
  }

  return <Outlet />;
};

export default RequireRole;
